import { Component } from '@angular/core';
import { NgbModalRef, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'lib-fw-horizontal-wrapper',
  templateUrl: './table-row-wrapper.component.html',
  styleUrls: ['./table-row-wrapper.component.scss'],
  imports: [NgbTooltip],
})
export class FormlyTableRowWrapperComponent extends FieldWrapper {

  private modalRef: NgbModalRef;
  public window: Window;

  public constructor() {
    super();
    this.window = window;
  }

  public get labelIndentCssClass(): string {
    return this.props.labelIndent ? 'pl-5' : null;
  }

  public close() {
    this.modalRef.close();
  }
}
